import { Component, OnDestroy } from '@angular/core';

import { LoginService } from 'src/app/services/login.service';
import { MyErrorStateMatcher } from 'src/app/utils/errorStateMatcher';
import { Router } from '@angular/router';
import { SpinnerService } from 'src/app/services/spinner.service';
import { StringUtils } from 'src/app/utils/stringUtils';
import { Subject } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-forgotten-password',
    templateUrl: './forgotten-password.component.html',
    standalone: false,
})
export class ForgottenPasswordComponent implements OnDestroy {

  matcher = new MyErrorStateMatcher();
  username: string = null;
  error: string;
  message: string;

  private destroy$ = new Subject<void>();

  constructor(
    private router: Router,
    private loginService: LoginService,
    private translate: TranslateService,
    private spinnerService: SpinnerService) {
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  forgotPassword(): void {
    this.spinnerService.show();

    this.error = null;
    this.message = null;

    if (StringUtils.isEmpty(this.username)) {
      this.error = this.translate.instant('login.username.error') as string;

      this.spinnerService.hide();

      return;
    }

    const username = this.username.trim();

    this.loginService.forgotPassword(username).pipe(takeUntil(this.destroy$))
      .subscribe(() => this.showMessageOk(), () => this.showMessageOk());

  }

  backLogin(): void {
    void this.router.navigate(['/login'], { queryParamsHandling: 'merge' });
  }

  private showMessageOk() {
    this.message = this.translate.instant('forgottenPassword.form.message') as string;

    this.spinnerService.hide();
  }

}
